// ################# coming soon scroll ###################

  // document.addEventListener("DOMContentLoaded", function () {

  //   // Only scroll on mobile (optional)
  //   if (window.innerWidth <= 768) {
  //     setTimeout(function () {
  //       const content = document.querySelector(".coming-soon-content");
  //       if (content) {
  //         content.scrollIntoView({ behavior: "smooth", block: "start" });
  //         // Tiny nudge to force scroll on some iOS versions
  //         // window.scrollBy(0, 1);
  //       }
  //     }, 3000);
  //   }
  // });

/*
  function smoothScrollTo(targetY, duration = 1000) {
    const startY = window.scrollY || window.pageYOffset;
    const distance = targetY - startY;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutCubic(progress);
      window.scrollTo(0, startY + distance * ease);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    function easeInOutCubic(t) {
      return t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    requestAnimationFrame(animation);
  }

  // Run after DOM is ready
  document.addEventListener("DOMContentLoaded", function () {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (window.innerWidth <= 768) {
      setTimeout(function () {
        const content = document.querySelector(".coming-soon-content");
        if (content) {
          const targetY = content.getBoundingClientRect().top + window.scrollY;
          smoothScrollTo(targetY, 2000); // 1500ms = 1.5 seconds scroll duration
        }
      }, 3000);
    }
  });
*/

// ######################################## coming soon validation ##############################

document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('#ContactFooter');
    const phoneInput = document.querySelector('#ContactForm-phone');
    const emailInput = document.querySelector('#ContactForm-email');
    const checkbox = document.querySelector('#accept');
    const submitButton = document.querySelector('.comming-btn-submit');
    const phoneError = document.querySelector('.error-coming-soon');
    const emailError = document.querySelector('.error-coming-soon-email');
    const checkboxError = document.querySelector('.error-coming-soon-checkbox');

    // Initially disable button and hide errors
    submitButton.disabled = true;
    submitButton.style.opacity = '0.5';
    checkboxError.style.display = 'none';

    // Validation functions
    const isValidPhone = phone => /^\d{10}$/.test(phone);
    const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    function validateForm() {
        const hasPhoneError = phoneInput.value && !isValidPhone(phoneInput.value);
        const hasEmailError = emailInput.value && !isValidEmail(emailInput.value);
        const isCheckboxChecked = checkbox.checked;
        
        // Show/hide error messages
        phoneError.style.display = hasPhoneError ? 'block' : 'none';
        emailError.style.display = hasEmailError ? 'block' : 'none';
        checkboxError.style.display = !isCheckboxChecked ? 'block' : 'none';
        
        // Button state
        const isFormValid = !hasPhoneError && !hasEmailError && isCheckboxChecked;
        submitButton.disabled = !isFormValid;
        submitButton.style.opacity = isFormValid ? '1' : '0.5';
    }

    // Phone validation
    phoneInput.addEventListener('input', function() {
        this.value = this.value.replace(/\D/g, '').slice(0, 10);
        validateForm();
    });

    // Email validation
    emailInput.addEventListener('input', function() {
        validateForm();
    });

    // Checkbox validation - specific handler
    checkbox.addEventListener('change', function() {
        checkboxError.style.display = this.checked ? 'none' : 'block';
        validateForm();
    });

    // Form submission
    form.addEventListener('submit', function(event) {
        if (!checkbox.checked) {
            event.preventDefault();
            checkboxError.style.display = 'block';
            return false;
        }
        validateForm();
        if (submitButton.disabled) {
            event.preventDefault();
            return false;
        }
    });

    // Initial validation
    validateForm();
});


// ######################################## coming soon validation end ##############################